import { storybookReady } from '../../../core/js/utils'

let storybook, settings

(async function () {
  storybook = await storybookReady()

  settings = storybook ? {
    debug: true
  } : (window.brandPage || {})

  document.querySelectorAll('.FlavorFair').forEach(item => {
    new Flavor(item)
  })
})()

class Flavor {
  constructor (element) {
    settings.debug && console.log('Flavor')

    this.element = element

    this.element.querySelectorAll('.Header__MenuTrigger,.MenuOverlay').forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault()
        this.toggleMenu()
      })
    })
  }

  toggleMenu(form) {
    settings.debug && console.log('toggleMenu')
    document.body.classList.toggle('ShowMenu')
  }
}
